import * as React from "react";
import { Switch, Route } from "react-router-dom";

import { MetaTags } from "../../../head";
import { Product } from "../../../models";
import ProductSearch from "../../ProductSearch";
import CategoryList from "./CategoryList";
import ProductList from "./ProductList";
import SelectedProduct from "./SelectedProduct";
import { PhoneInputProps } from "./PhoneInput";
import PhoneInputModal from "./PhoneInputModal";

import "./Step1.css";

export interface Step1Props extends PhoneInputProps {
  categoryItems: JSX.Element | JSX.Element[];
  productItems: JSX.Element | JSX.Element[];
  chosenProduct?: Product;
  productSearchHook(input: HTMLInputElement): void;
  handleClosePhoneInputModal: () => void;
  isShowingModal: boolean;
}

// TODO: replace <input> with PriceSearchInput (that needs refactoring into container first maybe)
const Step1 = (props: Step1Props) => (
  <div className="container step-1">
    <div className="row">
      <div className="col-md-8 col-md-offset-2">
        <h1 className="text-center">Bạn muốn thiết kế sản phẩm gì?</h1>
        <div className="step-1__search">
          <ProductSearch
            disableDropdown
            productSearchHook={props.productSearchHook}
          />
        </div>
        <Switch>
          <Route
            exact
            path="/wizard/step-1"
            render={routeProps => [
              <MetaTags key={0} title="Danh mục thiết kế" />,
              <CategoryList key={1} {...routeProps} {...props} />,
            ]}
          />
          <Route
            exact
            path="/wizard/step-1/products"
            render={routeProps => [
              <MetaTags key={0} title="Danh sách sản phẩm" />,
              <ProductList key={1} {...routeProps} {...props} />,
            ]}
          />
          <Route
            path="/wizard/step-1/products/:productId"
            render={routeProps => (
              <SelectedProduct {...routeProps} product={props.chosenProduct} />
            )}
          />
        </Switch>
      </div>
    </div>
    <PhoneInputModal
      isOpen={props.isShowingModal}
      handleClose={props.handleClosePhoneInputModal}
    />
  </div>
);

export default Step1;



// WEBPACK FOOTER //
// ./src/routes/Step1/components/Step1.tsx